export default __webpack_public_path__ + "static/1429-35b51d957597d27dc62fa940733ccc37.gif";